// extracted by mini-css-extract-plugin
export default {"shared":"\"../../shared/shared.module.css\"","sm":"576px","container":"CartContainer_container__P-qLB"};